import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from '../imagenes/logoutm.png'
import BusquedaVisitas from '../componentes/BusquedaVisitas';

const ConsultarVisitas = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                        <title>Historial de Visitas - Sistema de Administración Museo UTM</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <BusquedaVisitas />
        </>
    );
}

export default ConsultarVisitas; 